import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IShopOrderItemView } from '@x/ecommerce-shop/app/core/order/services/order-item-view.service';

@Component({
  selector: 'x-order-item-availability',
  templateUrl: './order-item-availability.component.html',
  styleUrls: ['./order-item-availability.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'x-order-item-availability',
  },
})
export class OrderItemAvailabilityComponent {
  @Input() item: IShopOrderItemView;

  language = {
    availabilityNote: $localize`:@@OrderItemAvailability.ExclusivelyAvailableIn.Note:This item is exclusively available for delivery in `,
  };
}
